export const formatDate = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit'
  });
};

export const formatTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  return d.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Função para calcular datas da semana a partir de uma data
export const calcularDatasSemana = (dataString) => {
  if (!dataString) return null;
  
  const data = new Date(dataString);
  const diaSemana = data.getDay();
  const diff = diaSemana === 0 ? -6 : 1 - diaSemana;
  
  const inicioSemana = new Date(data);
  inicioSemana.setDate(data.getDate() + diff);
  
  const fimSemana = new Date(inicioSemana);
  fimSemana.setDate(inicioSemana.getDate() + 6);
  
  return {
    inicio: inicioSemana,
    fim: fimSemana,
    formato: `${formatDate(inicioSemana)} - ${formatDate(fimSemana)}`
  };
};

// Formatar para exibição de dia da semana
export const getWeekdayName = (dayIndex) => {
  const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  return days[dayIndex] || '';
};

// Formatar para exibição curta
export const getShortWeekdayName = (dayIndex) => {
  const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  return days[dayIndex] || '';
};

// Verificar se uma data é hoje
export const isToday = (date) => {
  const today = new Date();
  const checkDate = new Date(date);
  
  return today.getDate() === checkDate.getDate() &&
         today.getMonth() === checkDate.getMonth() &&
         today.getFullYear() === checkDate.getFullYear();
};

// Verificar se uma data é passada
export const isPast = (date) => {
  const now = new Date();
  const checkDate = new Date(date);
  
  return checkDate < now;
};

// Função para calcular datas da semana baseada em uma data
export const calcularSemanaPorData = (dataString) => {
  if (!dataString) return { inicio: '', fim: '' };
  
  const data = new Date(dataString);
  const diaSemana = data.getDay();
  const diff = diaSemana === 0 ? -6 : 1 - diaSemana;
  
  const inicioSemana = new Date(data);
  inicioSemana.setDate(data.getDate() + diff);
  inicioSemana.setHours(0, 0, 0, 0);
  
  const fimSemana = new Date(inicioSemana);
  fimSemana.setDate(inicioSemana.getDate() + 7);
  fimSemana.setHours(23, 59, 59, 999);
  
  return {
    inicio: inicioSemana.toISOString().split('T')[0],
    fim: fimSemana.toISOString().split('T')[0]
  };
};

// NOVA FUNÇÃO: parseBackendDate - Analisa datas do backend
export const parseBackendDate = (dateString) => {
  if (!dateString) return null;
  
  // Se já for um objeto Date, retorna ele mesmo
  if (dateString instanceof Date) {
    return dateString;
  }
  
  // Tenta fazer parse da data (suporta diferentes formatos)
  const date = new Date(dateString);
  
  // Verifica se a data é válida
  if (isNaN(date.getTime())) {
    console.warn('Data inválida recebida do backend:', dateString);
    return new Date(); // Retorna data atual como fallback
  }
  
  return date;
};

// NOVA FUNÇÃO: formatar data para input type="date"
export const formatDateForInput = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  return d.toISOString().split('T')[0];
};

// NOVA FUNÇÃO: formatar data e hora para input type="datetime-local"
export const formatDateTimeForInput = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  // Ajusta para o fuso horário local
  const localDate = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};

// NOVA FUNÇÃO: formatar hora para input type="time"
export const formatTimeForInput = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

// NOVA FUNÇÃO: converter data para formato ISO do backend
export const toBackendISO = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  return d.toISOString();
};

// NOVA FUNÇÃO: formatar data completa em português
export const formatFullDate = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  return d.toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

// NOVA FUNÇÃO: formatar data e hora completas em português
export const formatFullDateTime = (date) => {
  if (!date) return '';
  
  const d = parseBackendDate(date);
  if (!d) return '';
  
  return d.toLocaleString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// NOVA FUNÇÃO: calcular diferença em dias entre datas
export const diffInDays = (date1, date2) => {
  const d1 = parseBackendDate(date1);
  const d2 = parseBackendDate(date2);
  
  if (!d1 || !d2) return 0;
  
  const diffTime = Math.abs(d2 - d1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// NOVA FUNÇÃO: adicionar dias a uma data
export const addDays = (date, days) => {
  const d = parseBackendDate(date);
  if (!d) return null;
  
  const newDate = new Date(d);
  newDate.setDate(d.getDate() + days);
  return newDate;
};

// NOVA FUNÇÃO: obter data de início da semana (segunda-feira)
export const getWeekStartDate = (date = new Date()) => {
  const d = parseBackendDate(date);
  if (!d) return new Date();
  
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  
  const startDate = new Date(d);
  startDate.setDate(d.getDate() + diff);
  startDate.setHours(0, 0, 0, 0);
  
  return startDate;
};

// NOVA FUNÇÃO: obter data de fim da semana (domingo)
export const getWeekEndDate = (date = new Date()) => {
  const startDate = getWeekStartDate(date);
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);
  endDate.setHours(23, 59, 59, 999);
  
  return endDate;
};
